var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "promo" }, [
    _c("p", { staticClass: "promo__heading" }, [_vm._t("heading")], 2),
    _c(
      "p",
      { staticClass: "promo__subheading body-sm text-center" },
      [_vm._t("subheading")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }